# AN APP ROW'S SCREENS, MERGED INTO THE CLIENT'S ROUTE TABLE — card
# 6ac022cba664bc34d57be8c5 (umbrella 6ac01b76a664bc34d57be442).
#
# The server injects ONE App row's manifest (common/hostedApp.coffee, the row
# CLIENT_MOBILE_APP_URL names) as window.hostedApps.mobile. Its entries become
# routes of the same router the built-in screens use (router/hash_router), so
# route(name, params) reaches either kind.
#
# THE RULES:
#
#   - Only the manifest's entries are routable, by their NAME. A component id or
#     App id in the URL is never a source: the route table is built here, from
#     the injected manifest, and the URL can only pick one of its keys.
#   - A built-in name and a manifest name share one namespace, and so do their
#     URLs. A manifest entry that collides with either is REFUSED, loudly: it is
#     left out of the table, and the refusal is logged and reported, so the
#     author sees why their screen is missing instead of the built-in screen
#     silently changing.
#   - A hosted screen requires a signed-in session: it runs with the user's
#     token, like the bundle does.
#
# The manifest key is the screen's URL, in BaseApp's own form: key 'Home' opens
# at #Home (router/hash_router's bare-key form), never under '#/…', which is
# the built-in screens' space.
#
# IMPORT-FREE ON PURPOSE: a pin loads this file as it is.

KEY_FORM = /^[A-Za-z][\w-]*$/

# {routes, refused, hosted}: the merged table, the entries left out (with the
# reason), and the hosted routes' names in manifest order.
#   builtIn     the shell's own route table (routes.coffee)
#   manifest    window.hostedApps.mobile.manifest
#   screenFor   (entry) -> the React component that renders it
export mergeHostedRoutes = (builtIn, manifest, screenFor) ->
  routes = Object.assign {}, builtIn
  names = {}
  names[entry.name] = true for own key, entry of builtIn when entry?.name?
  refused = []
  hosted = []
  for own key, entry of manifest ? {}
    reason =
      if not entry?.name? or not entry?.componentId?
        'it names no screen and no component'
      else if not KEY_FORM.test key
        "its key '#{key}' is not a plain route name (letters, digits, - and _)"
      else if routes[key]?
        "its key '#{key}' is already a route"
      else if names[entry.name]
        "its name '#{entry.name}' is already a route"
    if reason?
      refused.push {key, name: entry?.name, reason}
      continue
    names[entry.name] = true
    hosted.push entry.name
    routes[key] =
      name: entry.name
      hosted: true
      componentId: String(entry.componentId)
      requireLogin: true
      # The selected child rides in ?studentId, written with location 'replace'
      # as the parent switches children — dynamic, as on the built-in dashboard
      # (routes.coffee), so a switch does not remount the hosted screen.
      dynamic: ['studentId']
      component: screenFor(entry, key)
  {routes, refused, hosted}
